import {
  Box,
  Button,
  Grid2,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ErrorModal from "../../utils/ErrorModal";

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 0;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 2.5 + ITEM_PADDING_TOP,
      width: 150,
      background: "#EBF3FD",
    },
  },
};
const userRoles = [
  { name: "Buyer", value: "BUYER" },
  { name: "Purchase Head", value: "PURCHASE_HEAD" },
  { name: "Technical Manager", value: "TECHNICAL_MANAGER" },
  { name: "Technical Head", value: "TECHNICAL_HEAD" },
  { name: "Finance Manager", value: "FINANCE_MANAGER" },
  { name: "Finance Head", value: "FINANCE_HEAD" },
  { name: "CEO", value: "CEO" },
  { name: "CFO", value: "CFO" },
  { name: "CMD", value: "CMD" },
  { name: "COO", value: "COO" },
];
const CreateUser = () => {
  const [orgUser, setOrgUser] = useState();
  const user = JSON.parse(localStorage.getItem("user"));
  const orgId = JSON.parse(localStorage.getItem("org"));
  const { orgUserId } = useParams();
  const [errors, setErrors] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorMsg, setErrorMsg] = useState()

  useEffect(() => {
    const getOrg = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${user.username}`,
        { headers: { Authorization: `Bearer ${user.accessToken}` } }
      );
      if (
        !res.data.orgLogo &&
        !res.data.orgUsername &&
        !res.data.orgShortform
      ) {
        navigate(`/admin/org-details`);
      }
    };
    getOrg();
  }, []);

  const handleChange = (e) => {
    setOrgUser({ ...orgUser, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = orgUser || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[6-9]\d{9}$/;

    if (isEmpty(data.name)) newErrors.name = "Org Name is required";
    if (isEmpty(data.userRoleName))
      newErrors.userRoleName = "User Role is required";

    if (isEmpty(data.email)) {
      newErrors.email = "Admin Email ID is required";
    } else if (!emailRegex.test(data.email)) {
      newErrors.email = "Invalid email address";
    }

    if (isEmpty(data.mobile)) {
      newErrors.mobile = "Admin Mobile Number is required";
    } else if (!mobileRegex.test(data.mobile)) {
      newErrors.mobile = "Invalid mobile number (must be 10 digits)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setLoading(true)
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/org-user`,
        {
          orgId: orgId,
          username: user.username,
          name: orgUser.name,
          email: orgUser.email,
          mobile: orgUser.mobile,
          userRoleName: orgUser.userRoleName,
        },
        { headers: { Authorization: `Bearer ${user.accessToken}` } }
      );
      navigate(`/admin`);
    } catch (error) {
      setOpenError(true)
      setErrorMsg(error.response.data.Exception || "Something went wrong. Please try again")
    } finally {
      setLoading(false)
    }
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setLoading(true)
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/org-user?orgUserId=${orgUserId}`,
        {
          name: orgUser.name,
          username: user.username,
          email: orgUser.email,
          mobile: orgUser.mobile,
          userRoleName: orgUser.userRoleName,
        },
        { headers: { Authorization: `Bearer ${user.accessToken}` } }
      );
      navigate(`/admin`);
    } catch (error) {
      setOpenError(true)
      setErrorMsg(error.response.data.Exception || "Something went wrong. Please try again")
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    if (orgUserId !== undefined) {
      const getOrgUser = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/org-user?orgUserId=${orgUserId}`,
            { headers: { Authorization: `Bearer ${user.accessToken}` } }
          );
          setOrgUser(res.data);
        } catch (error) {
          console.log(error);
        }
      };

      getOrgUser();
    }
  }, []);

  const handleBack = () => {
    navigate(`/admin`);
  };
  return (
    <div style={{position: 'relative'}}>
      {loading && <div className="loading-div"></div>}
      <div className="dashboard-container">
        <Typography variant="h4">Enter User Details</Typography>
        <Grid2
          container
          columnSpacing={2}
          sx={{ width: "60%", margin: "auto" }}
          py={5}
        >
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              onChange={handleChange}
              value={orgUser && orgUser.name}
              className={`${errors.name && "input-error"}`}
            />
            {errors.name && <p className="error">{errors.name}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <label htmlFor="email">User Email ID</label>
            <input
              type="email"
              id="email"
              name="email"
              onChange={handleChange}
              value={orgUser && orgUser.email}
              className={`${errors.email && "input-error"}`}
            />
            {errors.email && <p className="error">{errors.email}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <label htmlFor="mobile">User Mobile Number</label>
            <input
              type="text"
              id="mobile"
              name="mobile"
              onChange={handleChange}
              value={orgUser && orgUser.mobile}
              className={`${errors.mobile && "input-error"}`}
            />
            {errors.mobile && <p className="error">{errors.mobile}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <label htmlFor="userRoleName">User Role</label>
            <Select
              className={`${errors?.userRoleName && "input-error"}`}
              name="userRoleName"
              id="userRoleName"
              onChange={handleChange}
              value={orgUser?.userRoleName}
              IconComponent={(props) => (
                <KeyboardArrowDownIcon {...props} fontSize="small" />
              )}
              MenuProps={MenuProps}
              displayEmpty
              sx={{
                display: "flex",
                borderRadius: "7px",
                padding: "8px 7px",
                fontSize: "14px",
                margin: "6px 0 20px 0",
                "& .MuiSelect-select": {
                  fontFamily: "Inter !important",
                  padding: "5px",
                },
                "&:hover": {
                  background: "#D8E9F0 !important",
                },
              }}
            >
              <MenuItem value="" disabled>
                Choose
              </MenuItem>
              {userRoles.map((user) => (
                <MenuItem key={user.value} value={user.value}>
                  {user.name}
                </MenuItem>
              ))}
            </Select>
            {errors.userRoleName && (
              <p className="error">{errors.userRoleName}</p>
            )}
          </Grid2>
        </Grid2>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        {orgUser && orgUser.orgUserId ? (
          <Button className="btn-contained" onClick={handleUpdate}>
            Update User
          </Button>
        ) : (
          <Button className="btn-contained" onClick={handleSubmit}>
            Create New User
          </Button>
        )}
      </Box>

      <ErrorModal open={openError} handleClose={() => setOpenError(false)} msg={errorMsg} />
    </div>
  );
};

export default CreateUser;
